"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _session = require("@mulesoft/exchange-ui-portals-store/lib/domains/session");
var _DeleteAssetModal = _interopRequireDefault(require("./DeleteAssetModal"));
var _modals = require("../../utils/modals");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  var assetFromState = _assets.selectors.asset(state, asset);
  var assetGA = {
    groupId: asset.groupId,
    assetId: asset.assetId
  };
  return {
    asset: _objectSpread(_objectSpread({}, asset), assetFromState),
    assetVersions: _assets.selectors.assetVersions(state, assetGA),
    dependents: assetFromState.dependents || [],
    hasDeleteError: _assets.selectors.assetUI(state).hasDeleteError,
    isDeletingAsset: _assets.selectors.isDeletingAsset(state),
    isPortalReArchitectureEnabled: _session.selectors.isPIRAEnabled(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var closeModal = _ref2.closeModal,
    isCurrent = _ref2.isCurrent,
    decreaseProfileAssetsCountRoot = _ref2.decreaseProfileAssetsCount,
    deleteAssetRoot = _ref2.deleteAsset,
    _ref2$router = _ref2.router,
    getPath = _ref2$router.getPath,
    push = _ref2$router.push,
    _onDelete = _ref2.onDelete;
  return {
    onClose: function onClose() {
      closeModal();
      dispatch(_assets.actions.clearDeleteAssetError());
    },
    onDelete: function () {
      var _onDelete2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(asset, deleteType) {
        var groupId, assetId, version, minorVersion, isDeleted;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              groupId = asset.groupId, assetId = asset.assetId, version = asset.version, minorVersion = asset.minorVersion;
              _context.next = 1;
              return dispatch(_assets.actions.deleteAsset({
                groupId: groupId,
                assetId: assetId,
                version: version,
                minorVersion: minorVersion,
                isCurrent: isCurrent,
                pushFn: push,
                getPath: getPath,
                closeModal: closeModal,
                deleteType: deleteType
              }));
            case 1:
              isDeleted = _context.sent;
              if (isDeleted) {
                deleteAssetRoot(asset);
                dispatch(_session.actions.decreaseProfileAssetsCount());
                dispatch(_assets.actions.updateMinorVersions({
                  asset: asset
                }));
                decreaseProfileAssetsCountRoot();
                _onDelete === null || _onDelete === void 0 || _onDelete();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onDelete(_x, _x2) {
        return _onDelete2.apply(this, arguments);
      }
      return onDelete;
    }()
  };
};
var mapRootDispatchToProps = function mapRootDispatchToProps(dispatch) {
  return {
    decreaseProfileAssetsCount: function decreaseProfileAssetsCount() {
      return dispatch(_session.actions.decreaseProfileAssetsCount());
    },
    deleteAsset: function deleteAsset(_ref3) {
      var groupId = _ref3.groupId,
        assetId = _ref3.assetId,
        version = _ref3.version;
      dispatch(_assets.actions.deleteAssetDetail({
        groupId: groupId,
        assetId: assetId,
        version: version
      }));
    }
  };
};
var DeleteAssetModalContainer = (0, _redux.compose)((0, _modals.setModalName)('DeleteAssetModal'), _exchangeReactHooks.withConfig, _exchangeReactHooks.withModal, _exchangeReactHooks.withRouter, (0, _reactRedux.connect)(null, mapRootDispatchToProps, null, {
  context: _exchangeReactHooks.RootStoreContext
}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_DeleteAssetModal.default);
var _default = exports.default = DeleteAssetModalContainer;
//# sourceMappingURL=DeleteAssetModal.container.js.map